import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $active?: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 91px;
	padding: 0 20px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	background-color: ${(props) =>
		props.$active ? 'rgba(255, 255, 255, 0.1)' : 'transparent'};
	transition: background-color 0.3s ease;
	cursor: pointer;

	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
	}
`;

const StyledLeftContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledImage = styled.img<{ $online?: boolean }>`
	width: 50px;
	height: 50px;
	border-radius: 50px;
	user-select: none;
	pointer-events: none;

	${(props) =>
		props.$online
			? css`
					padding: 2px;
					border: 2px solid #77de38;
			  `
			: css`
					filter: grayscale(1);
			  `}
`;

const StyledInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
`;

const StyledNameContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}

	.dot {
		width: 6px;
		height: 6px;
		border-radius: 6px;
		background: #77de38;
		box-shadow: 0 0 8px rgba(119, 222, 56, 0.5);
	}
`;

const StyledLastMessage = styled(Text)<{ $unread?: boolean }>`
	width: 230px;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	opacity: 0.5;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
	-webkit-line-clamp: 2;
	text-overflow: ellipsis;
`;

const StyledNewMessagesCounter = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 30px;
	background-color: #ff3e3e;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledTime = styled(Text)`
	position: absolute;
	top: 17px;
	right: 24px;
	font-weight: 400;
	font-size: 12px;
	color: #ffffff;
	opacity: 0.25;
`;

export {
	StyledContainer,
	StyledImage,
	StyledInfoContainer,
	StyledLastMessage,
	StyledLeftContainer,
	StyledNameContainer,
	StyledNewMessagesCounter,
	StyledTime,
};
